import React, {useState} from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  
  ToggleButton,
  ToggleButtonGroup 
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  prjDeptHeaderTyps,
  prjOrderHeaderTyps,
  prjSalesHeaderTyps,
  prjStatHeaderTyps,
  prjDeptHeaders,
  prjTargetRateHeaderTyps,
  prjExTargetRateHeaderTyps,
} from '../../utils/forecastStaticData';
import OrderStaticsHeadquerterRows from './OrderStaticsHeadquerterRows';

const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-head': {
      fontWeight: 'bold',
    },
  },
});

const OrderStaticsHeadquarterTable = ({ data, tableRef, selectPrjTyp, strMonth, endMonth }) => {
  const classes = useStyles();
  const [showKorean, setShowKorean] = useState(false);
  const getBgColor = (id) => {
    if (id?.includes('STAT')) return '#b0deff';
    if (id === 'OA') return '#e3f2fd';
    if (id === 'HM') return '#fff3e0';
    if (id === 'ES') return '#e8f5e9';
    return '#f5f5f5';
  };

  
const currentHeaders = prjDeptHeaders(strMonth, endMonth, '수주',selectPrjTyp === 'A' ?'연':'');

  return (
    <Box sx={{ width: '100%' }}>
      <Box 
        sx={{ 
          width: '100%', 
          display: 'flex', 
          alignItems: 'center',       
          gap: 2,                     
          mb: 0.5, 
          px: 1 // 좌우 여백 모두 부여
        }}
      >
        <ToggleButtonGroup
          value={showKorean}
          exclusive
          onChange={(e, nextValue) => {
            // 아무것도 선택 안 된 상태(null) 방지 및 상태 업데이트
            if (nextValue !== null) setShowKorean(nextValue);
          }}
          size="small"
          sx={{
            height: '32px',
            '& .MuiToggleButton-root': {
              fontSize: '0.75rem',
              fontWeight: 700,
              color: '#455a64',
              px: 1.5,
              // 선택되지 않은 버튼의 스타일
              border: '1px solid #cfd8dc', 
              '&.Mui-selected': {
                backgroundColor: '#1967d2', // 활성화 배경색
                color: 'white',              // 활성화 글자색
                '&:hover': {
                  backgroundColor: '#1967d2',
                },
              },
            },
          }}
        >
          <ToggleButton value={false}>숫자 적용</ToggleButton>
          <ToggleButton value={true}>한글 적용</ToggleButton>
        </ToggleButtonGroup>

        {/* 단위 표시 (오른쪽 끝으로 밀기) */}
        <Typography 
          variant="caption" 
          sx={{ 
            color: '#455a64', 
            fontWeight: 700, 
            fontSize: '0.75rem',
            marginLeft: 'auto'
          }}
        >
          (단위: {showKorean ? '한글 혼용' : '원'})
        </Typography>
      </Box>
   
      <Paper sx={{ my: 1, width: '100%', overflow: 'hidden' }}>
        <TableContainer
          sx={{ 
            width: '100%', 
            maxHeight: '70vh', // 스티키 헤더 체감을 위해 높이 제한 권장
            overflowX: 'auto' 
          }}
        >
          <Table 
            size="small" 
            className={classes.table} 
            ref={tableRef} 
            stickyHeader
            sx={{ 
              tableLayout: showKorean ? 'fixed' : 'auto', 
              width: showKorean ? '100%' : 'max-content',
              minWidth: '100%'
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell 
                  align="center" 
                  rowSpan={2} 
                  sx={{ 
                    bgcolor: '#f5f5f5', 
                    width: '90px !important', 
                    minWidth: '90px !important', 
                    maxWidth: '90px !important',
                    whiteSpace: 'normal',    // 줄바꿈 허용
                    wordBreak: 'break-all',  // 너비 초과 시 글자 단위로 내림
                    fontSize: '0.85rem',     // 폰트 크기 상향
                    fontWeight: 'bold',
                    lineHeight: 1.2,
                    padding: '4px 2px'
                  }}
                >
                  본부
                </TableCell>
                {currentHeaders
                .filter((header) => (header.id.includes('STAT') ? selectPrjTyp === 'A' : true))
                .map((header) => {
                  const isRateGroup = header.id === 'STATRATE' || header.id === 'EXSTATRATE';
                  let totalWidth = header.id === 'OA' ? 360 : (isRateGroup ? 80 : 120);

                  return (
                    <TableCell
                      key={header.val}
                      align="center"
                      colSpan={header.id === 'OA' ? 6 : 2}
                      sx={{ 
                        bgcolor: getBgColor(header.id), 
                        fontWeight: 800, 
                        padding: '6px 2px',
                        width: `${totalWidth}px !important`,
                        minWidth: `${totalWidth}px !important`,
                        maxWidth: `${totalWidth}px !important`,
                        whiteSpace: 'pre-wrap',   // 너비 벗어나면 자동 줄바꿈
                        wordBreak: 'keep-all', // 강제 줄바꿈
                        lineHeight: 1.1,
                        fontSize: '0.9rem' // 대분류 헤더 폰트 키움
                      }}
                    >
                      {header.name}
                    </TableCell>
                  );
                })}
              </TableRow>
              <TableRow>
                {currentHeaders
                .filter((header) => (header.id.includes('STAT') ? selectPrjTyp === 'A' : true))
                .map((header) => {
                  const headerTyp =
                    header?.id === 'EXSTATRATE' ? prjExTargetRateHeaderTyps :
                    header?.id === 'STATRATE' ? prjTargetRateHeaderTyps : 
                    header?.id?.includes('STAT') ? prjStatHeaderTyps : 
                    header?.id === 'OA' ? prjOrderHeaderTyps : 
                    header?.id === 'HM' ? prjDeptHeaderTyps : 
                    prjSalesHeaderTyps;

                  return headerTyp.map((typ, index) => {
                    const isRate = typ.id?.toLowerCase().includes('rate') || typ.id === 'salesProfitMargin';
                      
                    return (
                      <TableCell 
                        key={`${header.id}-${index}`}
                        align="center" 
                        sx={{ 
                          bgcolor: getBgColor(header.id),
                          width: isRate ? '40px !important' : '60px !important',
                          minWidth: isRate ? '40px !important' : '60px !important',
                          maxWidth: isRate ? '40px !important' : '60px !important',
                          fontSize: '0.8rem',     // 소분류 헤더 폰트 키움 (기존 0.7 -> 0.8)
                          padding: '4px 1px',
                          whiteSpace: 'pre-wrap',   // 너비 벗어나면 자동 줄바꿈
                          wordBreak: 'keep-all', // 강제 줄바꿈
                          lineHeight: 1.1,        // 줄바꿈 시 가독성을 위해 소폭 상향
                          fontWeight: 700
                        }}
                      >
                        {typ.name}
                      </TableCell>
                    );
                  });  
              })}
              </TableRow>
            </TableHead>

            <TableBody>
              {Array.isArray(data) && data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center" sx={{ py: 5 }}>
                    데이터가 없습니다.
                  </TableCell>
                </TableRow>
              ) : (
                <OrderStaticsHeadquerterRows
                  useKorean={showKorean}
                  headerRows={prjDeptHeaders(strMonth, endMonth)}
                  data={data}
                  selectPrjTyp={selectPrjTyp}
                />
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default OrderStaticsHeadquarterTable;
